import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CSSProperties, FC, HTMLAttributes, ReactNode } from 'react';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';
import { OrderIcon } from '../../../assets/svg/order';
import { IconButton } from '../../../components/icon-button/icon-button';
import { TableColumn } from '../use-table';

interface Props extends HTMLAttributes<HTMLTableRowElement> {
  index: number;
  columns: Record<string, ReactNode>;
  cols: Record<string, TableColumn>;
  orderable?: boolean;
  isExpanded?: boolean;
  onToggleExpand?: () => void;
  expandable?: boolean;
}

export const TableRow: FC<Props> = ({
  index,
  columns,
  cols,
  orderable,
  id = '',
  isExpanded,
  onToggleExpand,
  className,
  expandable,
}) => {
  const { attributes, listeners, isDragging, transform, transition, setNodeRef } = useSortable({
    id,
    data: { index },
  });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    opacity: isDragging ? 0.5 : 1,
    transition,
  };

  const columnKeys = Object.keys(columns);
  const lastKey = columnKeys[columnKeys.length - 1];

  return (
    <tr className={className} style={orderable ? style : undefined} data-table-row={id}>
      {orderable && (
        <td
          ref={setNodeRef}
          {...listeners}
          {...attributes}
          style={{
            textAlign: 'center',
            cursor: isDragging ? 'grabbing' : 'grab',
          }}
        >
          <OrderIcon />
        </td>
      )}

      {columnKeys.map((key) => (
        <td key={key} style={{ width: cols?.[key]?.width, maxWidth: cols?.[key]?.maxWidth }}>
          {columns[key]}
          {expandable && key === lastKey && onToggleExpand && (
            <IconButton
              variant="ghost"
              onClick={(e) => {
                e.stopPropagation();
                onToggleExpand();
              }}
            >
              {isExpanded ? <IoChevronUp /> : <IoChevronDown />}
            </IconButton>
          )}
        </td>
      ))}
    </tr>
  );
};
